module.exports = __webpack_public_path__ + "img/electric_icon_chargeur-dc.f9774278.svg";